import { NotificationCoreBase } from "./notification.core.base"


export class NotificationCore extends NotificationCoreBase {

}